<template>
<div>
<el-row>
<el-col :span="4"><div class="grid-content"></div></el-col>
<el-col :span="16">
<div class="title">
<h1>情境联系：产品创意设计
                        整合设计材料与方法
                        设计资源
                    </h1>
</div>
</el-col>
<el-col :span="4"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="6"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="picture">
<img src="../assets/project14_1.jpg.webp"/>
</div>
</el-col>
<el-col :span="6"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="abstract">
                    本研究探讨整合设计资源与设计材料的设计方法
                    并解释了文化心理学的基础。它专注于整合
                    产品创意设计中的设计资源和设计素材。本文概述了设计
                    基于用户中心设计（都柏林大学）整合设计资源和设计材料的过程
                    并开发了一个名为“上下文连接器 (CC)”的设计工具，使用文化符号（如设计
                    资源）和机器学习赋能的产品（作为设计材料）为例。
                    由于文化符号会影响人们使用和感知事物的方式，研究人员一直在研究
                    最近谈论很多关于如何提高机器学习赋能的用户体验
                    产品。通过实验找设计师用设计方法来完成
                    产品创意设计，已经有经验证据证实该方法可以
                    在一定程度上帮助设计师融合文化符号和机器学习赋能
                    产品在设计过程中更加合理、创新，提高设计效率和
                    经验。最后，本文分析了CC的优点和缺点以及适用范围
                    该设计方法的未来研究和应用。
                    <div class="paper_published">
<br/><br/>
                        Zou, N., Gong, Q.*, Li, X., Zhao, Z., Chai, C. (2023). Context Connection: A Product Creative Design Method for Integrating Design Materials and Design Resources. Creativity Research Journal, 36(4). （SSCI，Q1，学生一作）                    </div>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project14_2.jpg.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    材料
                </div>
<div class="text">
                    为了对所提出的方法进行实证研究，本研究开发了一种称为上下文连接器（CC）的设计工具。 “上下文连接”的方法是CC的基础。该产品创意设计工具附带一个名为“矩阵画布”的画布和一份完整的在线说明手册，描述了建议的设计流程（图 2）。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="sub-title">
                    研究选择与分析
                </div>
<div class="text">
                    用户的矩形、左侧和右侧的圆圈、圆圈的内容以及用户两侧的箭头都与图1中的相同。抽象的设计过程在图中由带有数字的圆圈表示。第1步研究用户的最终需求，第2步研究机器学习产品的用户识别，第3步展示机器学习产品的情境特征（即产品需求），第4步研究文化符号的识别，第5步研究文化符号的情境特征（即文化符号的特质），第6步将文化符号特征与产品需求进行比较，找出相似之处。
                  <br/><br/>  CC 手册中的步骤（即本节提供的设计实践中的流程）和设计流程描述如图 3 的右侧部分所示，连接线演示了这些步骤如何与基于 CC 的抽象设计流程相对应。本研究中提供给设计人员的手册中详细说明的阶段与基于 CC 的抽象设计过程并没有本质上的不同，尽管它们在每个步骤上并不完美对应，并且用于描述特定概念的措辞也有所不同。这是因为本研究希望为设计者提供一个更符合设计从业者认知的操作流程或概念描述，让设计者不至于误解本研究中提出的一些术语，花太多时间理解CC，从而影响他们最终的设计想法。
                </div>
</el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project14_3.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project14_4.png.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    矩阵画布
                </div>
<div class="text">
                    设计师必须根据语境特征，依次将产品需求、文化符号特征以及“目标用户角色”中的用户数据填写到矩阵画布的相应位置。
                  <br/><br/>  例如，智能省钱助手项目的设计者在问卷调查的基础上，专门针对6岁至12岁的儿童，为了确定他们对产品的需求，设计者还进行了问卷调查和家长访谈。最终选出15个需求。设计师随后通过文献查阅，为中国传统存钱罐“普曼”编制了12个品质清单。然后，设计师在画布的交叉网格上标记了她认为有联系的两个元素，并在“产品定义”区域中填写了产品概念的最终描述。例如，设计师仔细考虑了普曼“摇一摇，里面的钱就会发出声音”的特点，以及“产品达到储蓄目标时有奖励”的产品需求。随后她提出了“用硬卡代替真钱”、“内置舵机连接可以顶起上部齿轮和弹射器组合”等相应的产品定义。每行中指定为最终产品描述的排序参考的单元格数量应包含在“排名”列中。此示例的完整矩阵画布如图 4 所示。（有关此案例的最终设计输出，请参阅案例研究部分）

                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="sub-title">
                    程序
                </div>
<div class="text">
                    本次研究招募了25名具有两年以上产品设计学习经验的设计师，并举办了为期14天的研讨会。这25位设计师都是自愿参加我们实验的工业设计或产品设计专业的学生。我们特意选择至少在三年级的本科生中招募参与者，因为他们中的大多数人通过在设计课程中进行设计项目来在日常生活中保持高频率的设计创意活动。他们对产品概念创意设计也比较热衷，可能暂时还没有形成自己固定的创意模式，更适合新产品创意工具的测试者。参与者的年龄从 22 岁到 26 岁不等。其中四人是三年级学生，一名正在攻读博士学位。 （她听说了我们的实验，非常想参与），其他人已经是四年级了。我们的实验共有4名男性设计师和21名女性设计师参与，这与我们招募参与者的大学设计专业的男女比例相当接近。
                    <br/><br/> 本研究使用随机排序软件对参与者进行编号，并将他们分为A组（No.14-No.25）和B组（No.1-No.13）。研究人员指示每个小组使用相同的设计方案开始概念设计项目（设计一个实体产品，具有某种中国传统文化符号的特征，并使用机器学习技术作为产品功能之一）。 A 组由 12 名设计师组成。他们被指示在他们的项目中使用 CC，并被要求通过 3D 打印快速制作原型，以进行简短的用户演练。 B组共有13名成员，被要求在不进行用户研究的情况下，以头脑风暴的方式进行产品创意设计过程。实验开始前，研究人员向A组设计师介绍了CC。研讨会的第八天为 A 组和 B 组安排了中期展示，以检查进度并回答问题，并在研讨会的最后一天安排了演示报告。所有设计师最终都完成了他们的工作。图5显示了实验过程。附录 B 列出了 25 种设计成果的概念和细节（表 B1）。
                    <br/><br/>  25 名设计师完成产品创意设计后，制作了一份调查问卷，要求 A 组回答三个有关“易用性”的问题、两个有关“使用过程”的问题、两个有关“创意成果”的问题和五个有关“知识理解”的问题，以七点李克特量表对他们的体验进行评分（阿塔索伊 和 马丁斯 2016；达尔赫伊曾 和 现金 2021；雅各布斯 等人 2017）。按照李克特七分制，所有 25 名设计师都被要求评价他们对 都柏林大学的理解程度以及他们认为自己的创造力。附录 B 包含调查问卷内容列表（表 B2）。 A组的12位设计师也针对与问卷相同的四个主题进行了访谈，并征求了他们的反馈和建议。
                    <br/><br/>  邀请了20名工业设计硕士或博士生对所提出的25个概念进行评估；他们都不是研讨会参与者。这25个概念采用李克特七点量表，从“产品功能的创新”、“文化符号整合的创新”和“概念的整体评价”三个不同的维度进行评级。本研究还对三个典型案例进行了深入调查。

                </div>
</el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project14_6.jpg.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="sub-title">
                    欲了解更多信息，请访问已发表的论文。
                </div>
<div class="text">
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
</div>
</template>

<script>
    export default {
        name: "Project7Zh"
    }
</script>

<style scoped>
    .paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>